module.exports = __webpack_public_path__ + "media/images/landing/persons/peter-varga-9213f9b85aa4d5f8f6a5e9b813ac3844.jpeg";